import React from 'react'
import PropTypes from 'prop-types'

import { Card, List } from 'semantic-ui-react'
import pluralize from 'pluralize'

import CardProperty from 'Components/CardProperty'

const FAEventCardContent = ({ event }) => {
  return (
    <Card.Content extra>
      <List>
        <CardProperty icon="image" popUpContent="Shoots">
          {`${event.pictures / 5} ${pluralize('Shoot', event.pictures / 5)}`}
        </CardProperty>

        <CardProperty icon="image" popUpContent="Pictures">
          {`${event.pictures} ${pluralize('Picture', event.pictures)}`}
        </CardProperty>

        <CardProperty icon="user" popUpContent="Customers">
          {`${event.customers} ${pluralize('Customer', event.pictures)}`}
        </CardProperty>
      </List>
    </Card.Content>
  )
}

FAEventCardContent.propTypes = {
  event: PropTypes.object.isRequired,
}

export default FAEventCardContent
